<template>
	<div>
		<div v-if=" !getLoggedIn " class="contact_phone">
			<div class="contact_icone">
				<span class="pe-7s-headphones"></span>
			</div>
			<div class="contact_number">
				<p>{{ $t('Pedidos y logística') }}:</p>
				<span><a href="tel:+34918294003">+34 918 294 003</a></span>
			</div>
		</div>

		<div v-else class="shopmenu text-right"> 
			<div class="username text-center">
				{{ $t('Hola') }} <span>{{ getUsername }}</span>
			</div>
			<router-link :to="{name: 'line', params: { language: getLocale, lin: '1-AGUA' }}"><i class="pe-7s-home"></i></router-link>
			<!-- <router-link :to="{name: 'login'}"><i class="pe-7s-user"></i></router-link> --> 

			<template v-if=" getLoggedIn ">	
				<router-link :to="{name: 'user-dashboard', params: { language: getLocale }}"><i class="pe-7s-config"></i></router-link> 
				<router-link v-if=" getFavlistsVisibility " :to="{name: 'user-favlists', params: { language: getLocale }}"><i class="pe-7s-star"></i></router-link> 				
				<!-- <router-link :to="{name: 'user-orders'}"><i class="pe-7s-box1"></i></router-link> -->				
				<div class="cart_link">
					<router-link :to="{name: 'shopping-cart', params: { language: getLocale }}">
						<i class="pe-7s-cart"></i>
						<span v-if=" cartCount > 0 " class="cart_count">
							<img v-if=" getShoppingCartLoading " :src=" getBaseUrl + '/assets-own/images/loading-rainbow.svg' " width="12" height="12" alt="Spinning">	
							<span v-else>{{ cartCount }}</span>					
						</span>
					</router-link>			
				</div>
				<div 
					v-if=" getSessionEndTime "
					v-tooltip:top.live=" $t('Tiempo restante para que caduque su sesión') "
					class="session-watch" 					
				>
					<count-down :deadline="getSessionEndTime" class="mouseHoverPointer"></count-down>
				<!-- 	<span>|</span> 01:45:56 -->
				</div>
			</template>
		</div>
	</div>
</template>

<i18n>
  {
		"es": {
      "Pedidos y logística": "Pedidos y logística",
			"Hola": "Hola",
			"Tiempo restante para que caduque su sesión": "Tiempo restante para que caduque su sesión"
    },
    "en":{
      "Pedidos y logística": "Orders and logistics",
			"Hola": "Hi",
			"Tiempo restante para que caduque su sesión": "Time remaining for your session to expire"
    }
  }
</i18n>

<script>
	import { mapGetters, mapActions } from 'vuex'
	
	import MenuSidebar from './components/menus/MenuSidebar.vue';
	import CountDown from './components/helpers/CountDown.vue';

	export default {
		components: { MenuSidebar, CountDown },
	  data () {
	    return {
	    }
		},
		mounted () {
			//console.log('checkUser')
			this.$store.dispatch('checkUser').then(() => {
				//console.log('dispatch ok')
				if( this.getLoggedIn ){
					//console.log('loggedIn')
					this.$store.dispatch('loadShoppingCart');
				}
			})
			//  new Date(Date.now() + (10.2 * 60 * 1000)).toString()
			//console.log(this.getSessionEndTime)
		},
		computed: {
			...mapGetters(['getLocale', 'getBaseUrl', 'getLoggedIn', 'getShoppingCart', 'getShoppingCartLoading', 'getUsername','getSessionEndTime', 'getFavlistsVisibility']),
			cartCount: function(){
				//return this.getShoppingCart.length;
				return this.getShoppingCart.filter( (item) => { return item.ref_number != "PORTES1" } ).length
			},
		},
		methods: {
			...mapActions(['loadShoppingCart', 'checkUser']),		
		},
		watch: {
			/* $route(to, from) {
				// react to route changes...
				console.log('From: ' + to)
				console.log('To: ' + to)

    	} */
		},
	}
</script>

<style type="text/css">
	.shopmenu{ 
		padding: 20px 0 20px 20px;
		margin-left: 0; 
		font-size: 30px; 
	}
	.cart_link{
		display: inline;
		margin-left: 0;
	}
	.cart_link span.cart_count{
		/* background: #2D4A9A; */
		background: #2971f5;
		min-width: 18px;
    min-height: 18px;
    line-height: 18px;
		font-weight: 300;
	}
	a:hover{
		color: #2971f5;
	}
	.active{
		color: #2971f5 !important;
	}
	.username{
		font-size: 15px;
	}
	.session-watch{
		display: inline-block;
		font-size: 15px;
	}
	.session-watch span{ padding: 0 5px; }
	.mouseHoverPointer{ cursor: pointer; }
</style>
